// La barra de «Ordenar» abajo, centrada en lo que se ve de la oficina: qué se hace y «Listo» (el único botón dorado mientras
// se ordena). Las mesas son automáticas desde el 04-11: ya no hay «Volver al reparto automático». Desde el 04-11 (orden.md
// regla 16) se ordena la oficina entera de una vez (tiemblan todas las salas), no sala a sala.
import { Check } from 'lucide-react';
import { t } from '../../../i18n';

export function BarraOrdenar({ centroX, alListo }: { centroX: number; alListo: () => void }) {
  return (
    <div
      role="status"
      className="absolute bottom-4 z-40 flex max-w-3xl -translate-x-1/2 items-center gap-3 rounded-o-m bg-oficina-elevada px-4 py-2.5 text-o-sub text-oficina-texto2 shadow-o-hoja"
      style={{ left: centroX }}
    >
      <span className="leading-snug">{t('oficinaV2.mesas.aviso')}</span>
      <button
        type="button"
        onClick={alListo}
        className="flex shrink-0 items-center gap-1.5 rounded-o-s bg-oficina-acento px-3 py-1.5 text-o-sub font-semibold text-oficina-acento-tinta outline-none transition-colors hover:bg-oficina-acento-hover focus-visible:ring-2 focus-visible:ring-oficina-enlace"
      >
        <Check className="h-4 w-4" aria-hidden />
        {t('oficinaV2.mesas.listo')}
      </button>
    </div>
  );
}
